import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';

export interface NutzungsbedingungenProps {
    data: any;
}

export class Nutzungsbedingungen extends React.Component<NutzungsbedingungenProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', minHeight: 0, overflowY: 'auto' }}>
                <div style={{ padding: 20, paddingRight: 40, maxWidth: 600, textAlign: 'justify' }}>
                    {renderText('Nutzungsbedingungen', this.props.data)}
                </div>
                <div
                    style={{
                        padding: 20, paddingLeft: 40, maxWidth: 600, textAlign: 'justify', borderLeft: '1px solid #aaa', height: 3420
                    }}
                >
                    {renderText('Datenschutz', this.props.data)}
                </div>
           </div>
        );
    }
}
